

































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import SidebarItem from './SidebarItem.vue'
import variables from '@/styles/_variables.scss'
import { UserModule } from '@/store/modules/user'
import { asyncRoutes } from '@/router'
import { getApply } from '@/utils/cookies'
@Component({
  name: 'SideBar',
  components: {
    SidebarItem
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }

  get routes() {
    this.filterIcon(asyncRoutes, UserModule.roles)
      return UserModule.roles
  }

  get variables() {
    return variables
  }

  get activeMenu() {
    const route = this.$route as any
    const { meta, path } = route
    if (meta.activeMenu) {
      return meta.activeMenu
    }
    return path
  }

  get isCollapse() {
    return !this.sidebar.opened
  }

  get projectName() {
    return getApply() ? JSON.parse(getApply() as any).name : null
  }

  get projectLogo() {
    return getApply() ? JSON.parse(getApply() as any).logo : null
  }

  // 匹配默认图标
  filterIcon(arrRoutes:any, arrRoles:any) {
    arrRoles.forEach((obj:any) => {
      arrRoutes.forEach((val:any) => {
          if (val.children) {
              if (obj.meta.icon === '' && obj.meta.title === val.children[0].meta.title) {
                obj.meta.icon = val.children[0].meta.icon
              }
          }
        })
    })
  }
}
